{
  "exitDemoButton": "Salir de la demostración",
  "exploreTheAppInDemoMode": "Explora la aplicación FarmHQ usando una granja de demostración:",
  "indicatorText": {
    "isEnabled": "Modo de demostración"
  },
  "isActiveText": "Modo de demostración activo",
  "loadDemoButton": "Cargar demostración",
  "permissionDenied": "Esta función está deshabilitada en el modo de demostración.",
  "toasts": {
    "isEnabled": "Modo de demostración habilitado"
  },
  "tryTheDemo": "Pruebe la demostración",
  "warnings": {
    "someFeaturesDisabled": "Esta es una demostración de la aplicación FarmHQ. Algunas funciones están deshabilitadas."
  }
}
